import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface FloatingWidgetProps {
  children: ReactNode
  trigger?: ReactNode
  open?: boolean
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left'
  className?: string
}

const positionClass = {
  'bottom-right': 'floating-widget-bottom-right',
  'bottom-left': 'floating-widget-bottom-left',
  'top-right': 'floating-widget-top-right',
  'top-left': 'floating-widget-top-left',
}

export function FloatingWidget({ children, trigger, open = true, position = 'bottom-right', className }: FloatingWidgetProps) {
  return (
    <div className={cn('floating-widget', positionClass[position], className)}>
      {open && <div className="floating-widget-panel">{children}</div>}
      {trigger && <div className="floating-widget-trigger">{trigger}</div>}
    </div>
  )
}
